import styled from "styled-components"

import Photo0501 from "../../img/05_01.jpg"
import Photo0502 from "../../img/05_02.jpg"
import Photo0503 from "../../img/05_03.jpg"
import Photo0504 from "../../img/05_04.jpg"
import Photo0505 from "../../img/05_05.jpg"
import Photo0506 from "../../img/05_06.jpg"
import Photo0507 from "../../img/05_07.jpg"
import Photo0508 from "../../img/05_08.jpg"
import Photo0509 from "../../img/05_09.jpg"

const ContentBase05 = styled.div`
  background: #111;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
`

function SubMenuContent05() {
  return (
    <ContentBase05>
      <div className="typobase02">
        가상광고는 TV광고 방식 변화에서 중요한 부분을 차지합니다. 종편, 케이블
        채널 확장에 ARA(초단위 시청률) 도입과 지상파 시청률 감소에 따라 종편과
        케이블은 이미 가상광고를 도입하고 있는 상황입니다. K-Shopping(KTH)과
        KBS가 협력하여 TV와 모바일을 연동하는 채널연동형커머스를
        진행합니다.KBS방송중에 가상 트리거를 띄워서 K-Shopping 기획 상품을
        홍보하고 모바일 링크를 전송하는 방식입니다.
      </div>
      <div className="typotitle">Verture AD (link to Mobile)</div>
      <div className="video-wrap">
        <iframe
          autoPlay="1"
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/H0FIOVaSNnw"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0501} className="photobase" alt="Photo0501"></img>
      <img src={Photo0502} className="photobase" alt="Photo0502"></img>
      <img src={Photo0503} className="photobase" alt="Photo0503"></img>
      <img src={Photo0504} className="photobase" alt="Photo0504"></img>
      <img src={Photo0505} className="photobase" alt="Photo0505"></img>
      <div className="typobase02">
        K-Shopping에서는 모바일 연동방식 가상광고 말고도 T-커머스 채널과의 연동
        방식으로도 광고를 진행합니다. 방송중에 가상 트리거를 띄워서 K-Shopping
        TV-App 기획전 상품을 홍보하고 채널 진입을 유도하는 방식입니다.
      </div>
      <div className="typotitle">Verture AD (link to TV-APP/ARS)</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/VpmlRt4SPv0"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0505} className="photobase" alt="Photo0505"></img>
      <img src={Photo0506} className="photobase" alt="Photo0506"></img>
      <img src={Photo0507} className="photobase" alt="Photo0507"></img>
      <img src={Photo0508} className="photobase" alt="Photo0508"></img>
      <img src={Photo0509} className="photobase" alt="Photo0509"></img>
    </ContentBase05>
  )
}

export default SubMenuContent05
